export const experienceData = [
    {
        id: 1,
        company: 'DaroSoft',
        jobtitle: 'Web Developer',
        startYear: 'May 2025',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'The Alifa',
        jobtitle: 'Web Developer',
        startYear: 'Jan 2025',
        endYear: 'May 2025'
    },
    {
        id: 3,
        company: 'MS Global Inc.',
        jobtitle: 'Mid-Level Frontend Developer',
        startYear: 'Aug 2024',
        endYear: 'Dec 2024'
    },
    {
        id: 4,
        company: 'Yadgar Safar',
        jobtitle: 'Frontend Developer',
        startYear: 'Aug 2023',
        endYear: 'Aug 2024'
    },
    {
        id: 5,
        company: 'EduTrainia',
        jobtitle: 'Software Engineer',
        startYear: 'July 2022',
        endYear: 'June 2023'
    }
]